module.exports = "<pre>\n    <code :class=\"['language-' + type]\">\n        {{code}}\n    </code>\n</pre>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/components/source-code.vue
 ** module id = 371
 ** module chunks = 0
 **/